<div class="main-container">
    <h3 *ngIf="!isToday">This is an invalid QR code</h3>
    <div *ngIf="isToday">
        <h3>RM Branch Check-In</h3>
    </div>
    <div class="body-content" *ngIf="isToday">
        <p *ngIf="checkIn"> We would like to <b>confirm your check-in details,
                including the date, time, and location</b>.
            Please be advised that this information,
            along with your device details,
            will be forwarded to Central Support for reporting purposes
        </p>
        <p *ngIf="!checkIn"> Thank you, your <b>details have been sent and you are now checked-in</b>.
        </p>
    </div>
    <div class="body-content-footer" *ngIf="isToday">
        <p *ngIf="checkIn"> Thank you for your cooperation.</p>
    </div>
    <button *ngIf="checkIn && isToday" class="btn btn-success modal-button" [ngClass]="{'loading': isCheckedIn}"
        (click)="rmCheckIn()">
        Check-In
    </button>
</div>